// extracted by mini-css-extract-plugin
export var accent = "Timeline-module--accent--787a8";
export var active = "Timeline-module--active--15d83";
export var box = "Timeline-module--box--b2e20";
export var bullet = "Timeline-module--bullet--8f619";
export var date = "Timeline-module--date--7bf61";
export var inline = "Timeline-module--inline--55238";
export var item = "Timeline-module--item--210b1";
export var overlay = "Timeline-module--overlay--c8148";
export var point = "Timeline-module--point--c73d3";
export var springLeft = "Timeline-module--spring-left--d64f3";
export var springRight = "Timeline-module--spring-right--369a0";
export var timeline = "Timeline-module--timeline--68528";